import { Spinner } from "../../../../components/spinner";

const Loader = () => {
    return (
        <div className="flex items-center justify-center m-10 h-100 py-32">
            <div className="animate-spin mr-8">
                <Spinner />
            </div>
            <div
                className="
                text-lg
                font-semibold
                text-gray-500
            "
            >
                Connecting to device...
            </div>
        </div>
    );
};

export default Loader;
